<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <ActivityFiltersVue :filters="filters" @update="updates" />
    <hr />
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group v-if=" ['super_admin','distribution'].includes($role)">
          <b-button variant="outline-danger">
            <input
              v-model="selectAll"
              type="checkbox"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
          >
            <i class="fa fa-trash" />
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div
        class="col-md-3"
        v-if="$role != 'teacher' && updateDate.edu_course_id"
      >
        <b-button v-b-modal.modal-center variant="outline-info">
          {{ $t("activities.update_date") }}
        </b-button>
      </div>
      <div
        :class="
          updateDate.edu_course_id && $role != 'teacher'
            ? 'col-md-3'
            : 'col-md-6'
        "
      >
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
            >
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                v-model="recordIds"
                type="checkbox"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span />
            </label>
          </template>
          <template #cell(questions)="data">
            <b-button
              v-b-modal.modal-scrollable
              variant="outline-info"
              @click="questions(data.item)"
            >
              {{ $t("activities.show") }}
            </b-button>
          </template>
          <template #cell(students)="data">
            <b-button
              variant="outline-info"
              :to="{
                name: 'activityStudents',
                params: { Activity: data.item.id },
              }"
            >
              {{ $t("students.students") }}
            </b-button>
          </template>
          <template #cell(edit)="data">
            <!-- :disabled="$role == 'teacher' && data.item.start_answers === 1" -->
            <button
              class="btn btn-icon btn-warning btn-sm"
              @click="editItem(data)"
              :disabled="$role == 'teacher' && data.item.start_answers === 1"
            >
              <i class="fa fa-edit" />
            </button>
            <button
              class="btn btn-icon btn-danger btn-sm"
              @click="deleteItem(data)"
              v-if=" ['super_admin','distribution'].includes($role)"
            >
              <i class="fa fa-trash" />
            </button>
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <!-- <b-modal
      id="modal-info"
      ok-only
      ok-variant="info"
      modal-class="modal-info"
      centered
      size="lg"
    >
    <div v-if="questionsArr.length>0">
    <b-card>
      <b-card-title>
        <h3 class="card-label" id="question">
          {{ index + "-" + questionsArr[index - 1].question }}
        </h3>
      </b-card-title>
      <b-card-body>
        <quiz-vue :answers="questionsArr[index - 1].answers"  :myAnswers="myAnswers" @update="testanswer"/>
      </b-card-body>
      <b-card-footer class="d-flex justify-content-between">
        <b-button
          variant="relief-primary"
          class="col-4"
          v-if="index != 1"
          @click="index--"
          >سابق</b-button
        >
        <b-button
          variant="relief-info"
          class="col-4"
          v-if="questionsArr.length > index"
          @click="index++"
          >التالي</b-button
        >
        <b-button
          variant="relief-success"
          class="col-4"
          v-if="questionsArr.length == index"
          >انتهى</b-button
        >
      </b-card-footer>
    </b-card>
  </div>
    </b-modal> -->
    <b-modal
      id="modal-scrollable"
      scrollable
      :title="$t('activities.questions')"
      ok-only
      :ok-title="$t('activities.done')"
      size="lg"
    >
      <b-row>
        <b-col lg="12">
          <b-form v-for="(q, k) in questionsArr" :key="k">
            <b-row>
              <b-col
                lg="2"
                v-if="questionsType === 'exam' || questionsType === 'homework'"
              >
                <label>{{ $t("activities.question") }} {{ k + 1 }}</label>
              </b-col>
              <b-col lg="10">
                <b-form-input type="text" :value="q.question" disabled />
              </b-col>
            </b-row>
            <br
              v-if="questionsType === 'exam' || questionsType === 'homework'"
            />
            <b-row v-for="(answer, ke) in q.answers" :key="ke">
              <b-col lg="6">
                <b-form-input type="text" :value="answer.answer" disabled />
              </b-col>
              <b-col lg="2">
                <b-form-radio
                  v-model="selected"
                  name="answer"
                  :value="answer.type"
                  class="custom-control-success"
                  disabled
                >
                </b-form-radio>
              </b-col>
            </b-row>
            <hr
              v-if="questionsType === 'exam' || questionsType === 'homework'"
            />
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-center" centered ok-only ok-title="save" @ok="handleOk">
      <b-col lg="12">
        <div class="form-group">
          <label>{{ $t("activities.start_date") }}</label>
          <b-datepicker v-model="updateDate.start_date"></b-datepicker>
        </div>
      </b-col>
      <b-col lg="12">
        <div class="form-group">
          <label>{{ $t("activities.end_date") }}</label>
          <b-datepicker
            v-model="updateDate.end_date"
            :min="updateDate.start_date"
          ></b-datepicker>
        </div>
      </b-col>
    </b-modal>
  </div>
</template>

<script>
import controller from "../../../../Controllers/ActivitiesController";
import config from "../../../../config/config";
import ActivityFiltersVue from "./ActivityFilters.vue";
import quizVue from "./quiz.vue";
import Auth from "../../../../Apis/Auth";

export default {
  name: "ActivitiesDataTable",
  props: ["items", "editItem"],
  components: {
    ActivityFiltersVue,
    quizVue,
  },
  data() {
    return {
      filters: {},
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "name",
            label: this.$i18n.t("activities.name"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "type",
            label: this.$i18n.t("activities.type"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "grade",
            label: this.$i18n.t("activities.grade"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "start_date",
            label: this.$i18n.t("activities.start_date"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "end_date",
            label: this.$i18n.t("activities.end_date"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "questions",
            label: this.$i18n.t("activities.questions"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "students",
            label: this.$i18n.t("students.students"),
            sortable: true,
          },
          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      questionsArr: [],
      questionsType: "",
      selected: "1",
      index: 1,
      myAnswers: [],
      updateDate: {},
    };
  },
  created() {
    if (Auth.USER.account_type === "admin") {
      console.log("manaa");
      this.bootstrapTable.fields.splice(0, 0, {
        key: "checkbox",
        label: "",
        sortable: false,
      });
    }
  },
  methods: {
    async updates() {
      console.log(this.filters);
      if (this.filters.edu_course && this.filters.edu_course != null) {
        let ret = await this.getCourseActivitesDate({
          edu_course_id: this.filters.edu_course,
        });
        if (!ret.id) {
          this.updateDate = {};
        } else {
          this.updateDate.edu_course_id = this.filters.edu_course;
          this.updateDate.start_date = ret.start_date;
          this.updateDate.end_date = ret.end_date;
        }
      } else {
        this.updateDate = {};
      }
      console.log(this.updateDate);
      this.$refs.table.refresh();
    },
    questions(item) {
      this.questionsArr = item.questions;
      this.questionsType = item.type;
      console.log(this.questionsArr);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (this.filters.edu_course) {
        apiParams.edu_course = this.filters.edu_course;
      }
      if (this.filters.type) {
        apiParams.type = this.filters.type;
      }
      if (Auth.USER.account_type === "teacher") {
        apiParams.edu_program = localStorage.getItem("eduProgram");
      }
      apiParams.with = ["questions"];
      console.log(apiParams);
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
    testanswer() {
      console.log("manaa");
      console.log(this.myAnswers);
    },
    async handleOk() {
      await new controller().updateDates(this.updateDate);
      this.$refs.table.refresh();
    },
    async getCourseActivitesDate(params) {
      return await new controller().getCourseActivitesDate(params);
    },
  },
};
</script>
